/**
 * react-tabs base styles — import only from components that render react-tabs.
 * Kept out of global index.scss so pages without tabs skip this CSS.
 */
import 'react-tabs/style/react-tabs.css'
